export const ptLang = {
  languageKey: 'pt',
  translates: {
    // log_in: 'Iniciar sessão',
    // logging_in: 'A iniciar sessão...',
    // log_out: 'Fechar Sessão',
    // logout: 'Fechar Sessão',
    // search: 'Buscar',
    // generate_password: 'Gerar senha',

    // // language selector:
    // english: 'Inglês',
    // spanish: 'Espanhol',
    // portuguese: 'Português',

    // // TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.
    // dashboard: 'Dashboard',
    // profile: 'Perfil',
    // my_profile: 'My Profile',
    // detail: 'Detail',
    // edit: 'Edit',
    // 'billing-info': 'Dados para faturação',
    // 'requester-companies': 'Gestores do processo',
    // 'supplier-companies': 'Empresas de avaliação',
    // list: 'Listado',
    // entities: 'Entidades',
    // // END - TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.

    // // ERRORS
    // required: 'Required field',
    // not_valid_email: 'Not a valid email',
    // // END - ERRORS

    // MENU_dashboard: 'Panel de control',
    // MENU_ORDERS_requests: 'Solicitudes',
    // MENU_ORDERS_list: 'Listado',
    // MENU_ASSETS_assets: 'Activos',
    // MENU_ENTITIES: 'Entidades',
    // MENU_ENTITIES_prescribers: 'Gestores do processo',
    // MENU_ENTITIES_customers: 'Clientes',
    // MENU_ENTITIES_appraisal_companies: 'Empresas de avaliação',
    // MENU_ENTITIES_users: 'Usuarios',

    // Code: 'Código',
    // code: 'Código',
    // PrescriptorType: 'Tipo de prescriptor',
    // Name: 'Nome',
    // name: 'Nome',
    // add_prescriber: 'Adicionar Gestores do processo',
    // prescribers: 'Gestores do processo',
    // appraisals: 'Avaliações',
    // users: 'Usuarios',
    // IsActive: 'Utilizador ativo',
    // FirstName: 'Nome',
    // LastName: 'Apelido',
    // Requester: 'Gestor do processo',
    // Email: 'Email',
    // email: 'Email',
    // deliverables: 'Entregas',
    // billing_info: 'Dados para faturação',
    // typology: 'Tipologia',
    // cif_nif: 'CIF/NIF',
    // cif: 'CIF',
    // nif: 'NIF',
    // phone: 'telefone',
    // description: 'descrição',
    // observations: 'observações',
    // IrpfPercentage: 'Porcentaje de Retención de IRPF (%)',
    // BillingTaxType: 'Tipo do imposto',
    // tax: 'Imposto',
    // bank_account_number_for_payment: 'Número da conta bancária para pagamento',

    // name_or_business_name: 'Nome ou firma',
    // withholding: 'Retenção de IRS',
    // tax_type: 'Tipo de imposto',

    // restart: 'Reiniciar',
    // filter: 'Filtrar',
    // cancel: 'Cancelar',
    // save: 'Salvar',
    // close: 'Close',
    // confirm: 'Confirmar',

    // RecordId: 'número de registro',
    // GestasaId: 'No. Gestasa',
    // ExternalRecordId: 'No. de referencia externa',
    // Address: 'Dirección',
    // address: 'Dirección',
    // Locality: 'Localidad',
    // Province: 'Provincia',
    // AddedDateTime: 'Fecha de creación',
    // CurrentWorkflowStep: 'Estado',
    // ProcessManagerUser: 'Gestor de procesos',
    // TechnicalManagerUser: 'Gestor de técnicos',
    // Customer: 'Cliente',
    // customer: 'Clientes',

    // postalCode: 'Código Postal',
    // gate: 'Porta',
    // floor: 'Andar',
    // stairs: 'Escadas',
    // entrance: 'Entrada',
    // number: 'Número',
    // streetName: 'Rua',
    // roadType: 'Tipo de rua',
    // change_picture: 'Alterar imagem',

    // AppraisalStatus_1: '1 - INSCRIÇÃO',
    // AppraisalStatus_2: '2 – RESPONSÁVEL ATRIBUÍDO',
    // AppraisalStatus_3: '3 – TÉCNICO ATRIBUÍDO',
    // AppraisalStatus_4: '4 – VISITA AGENDADA',
    // AppraisalStatus_5: '5 – VISITA INICIADA',
    // AppraisalStatus_6: '6 - VISITA CONCLUÍDA',
    // AppraisalStatus_7: '7 - RELATÓRIO ENTREGUE',
    // AppraisalStatus_8: '8 – AVALIADOR ATRIBUÍDO',
    // AppraisalStatus_9: '9 – VALIDAÇÃO INICIADA',
    // AppraisalStatus_10: '10 – VALIDAÇÃO CORRETA',
    // AppraisalStatus_11: '11 - ENTREGUE AO CLIENTE',

    // DELIVERABLE_REPOSITORY_addRow: '+ Adicionar novo produto',
    // DELIVERABLE_REPOSITORY_deliverable: 'Entregável',
    // DELIVERABLE_REPOSITORY_orderType: 'Tipo de pedido',
    // DELIVERABLE_REPOSITORY_prupose: 'Finalidade',
    // DELIVERABLE_REPOSITORY_source: 'Origem',

    // DELIVERABLE_MODAL_deliverable: 'Entregável',
    // DELIVERABLE_MODAL_documentName: 'Nome do documento',
    // DELIVERABLE_MODAL_generationDate: 'Data da geração',
    // DELIVERABLE_MODAL_emissionDate: 'Data de emissão',
    // DELIVERABLE_MODAL_expirationDate: 'Data de validade',
    // DELIVERABLE_MODAL_documentVersion: 'Versão do documento',
    // DELIVERABLE_MODAL_downloadAll: 'Baixar tudo',
    // DELIVERABLE_MODAL_downloading: 'Download',
    // DELIVERABLE_MODAL_internal: 'Interno',
    // DELIVERABLE_MODAL_external: 'Externo',

    // add_new_prescriptor: '+ Adicionar novo gestor do processo',

    // an_error_has_ocurred: 'Ocorreu um erro',
    // the_action_was_successful: 'A ação foi bem sucedida',
    // successfully_completed: 'Executado com sucesso',
    // account_number_for_payments: 'Número da conta bancária para pagamento',

    // PROPERTY_DATA_TABLE_CadastralReference: 'Referência cadastral',
    // PROPERTY_DATA_TABLE_RegistryInfoRegister: 'Registro de propriedade',
    // PROPERTY_DATA_TABLE_RegistryInfoRegisterNumber: 'Número da propriedade do registro',
    // PROPERTY_DATA_TABLE_RegistryInfoIdufir: 'C.R.U. (IDUFIR)',
    // PROPERTY_DATA_TABLE_RegistryInfoVolume: 'Tomo',
    // PROPERTY_DATA_TABLE_RegistryInfoBook: 'Livro',
    // PROPERTY_DATA_TABLE_RegistryInfoSection: 'Folio',
    // PROPERTY_DATA_TABLE_RegistryInfoInscription: 'Inscription',
    // PROPERTY_DATA_TABLE_RegistryInfoRealEstateNumber: 'Propriedade de registro',
    // PROPERTY_DATA_TABLE_adress: 'Endereço',
    // PROPERTY_DATA_TABLE_refCatastral: 'Ref. catastral',
    // PROPERTY_DATA_TABLE_tipologyAndUse: 'Uso e tipologia',
    // PROPERTY_DATA_TABLE_surface: 'Superfície',
    // PROPERTY_DATA_TABLE_antiquity: 'Antiguidade',
    // PROPERTY_DATA_TABLE_estimatedValueBand: 'Intervalo de valor estimado',
    // PROPERTY_DATA_TABLE_total: 'Total:',
    // PROPERTY_DATA_TABLE_prupsedProperty: 'Taxa proposta',
    // ORDER_REQUEST_DETAIL_registerData: 'dados do registro',
    // ORDER_REQUEST_DETAIL_euro: 'EUROS (sem IVA).',

    // ADD_NEW_ASSET_FORM_location: 'Location',
    // ADD_NEW_ASSET_FORM_addManualy: 'Adicionar manualmente',
    // ADD_NEW_ASSET_FORM_province: 'Province',
    // ADD_NEW_ASSET_FORM_municipality: 'Município',
    // ADD_NEW_ASSET_FORM_streetName: 'Nome do caminho',
    // ADD_NEW_ASSET_FORM_number: 'Number',
    // ADD_NEW_ASSET_FORM_Block: 'Block',
    // ADD_NEW_ASSET_FORM_Stairs: 'Escada',
    // ADD_NEW_ASSET_FORM_Floor: 'Floor',
    // ADD_NEW_ASSET_FORM_Gate: 'Door',
    // ADD_NEW_ASSET_FORM_Use: 'Use',
    // ADD_NEW_ASSET_FORM_Typologies: 'Tipologia',
    // ADD_NEW_ASSET_FORM_Surface: 'Surface',
    // ADD_NEW_ASSET_FORM_ConstructionYear: 'Idade',
    // ADD_NEW_ASSET_FORM_cadastralReference: 'Referência cadastral',
    // ADD_NEW_ASSET_FORM_propertyRegister: 'Registro de propriedade',
    // ADD_NEW_ASSET_FORM_propertyRegisterNumber: 'Número de propriedade registrado',
    // ADD_NEW_ASSET_FORM_idufir: 'C.R.U (IDUFIR)',
    // ADD_NEW_ASSET_FORM_volume: 'Tomo',
    // ADD_NEW_ASSET_FORM_book: 'Livro',
    // ADD_NEW_ASSET_FORM_paper: 'Fólio',
    // ADD_NEW_ASSET_FORM_inscription: 'Inscription',
    // ADD_NEW_ASSET_FORM_realState: 'Finca',
    // ADD_NEW_ASSET_FORM_add: 'Adicionar',
    // ORDER_REQUEST_DETAIL_addNewAsset: '+ Adicionar novo ativo',
    // ORDER_REQUEST_DETAIL_cancel: '- Cancelar',
    // ORDER_REQUEST_DETAIL_showDetail: 'Ver detalhe',

    // InvoiceStatus_0: 'Solicitação de confirmação pendente',
    // InvoiceStatus_1: 'Confirmação enviada',
    // InvoiceStatus_2: 'Confirmado',
    // InvoiceStatus_3: 'Rejeitado',

    // MonthsEnum_1: 'Janeiro',
    // MonthsEnum_2: 'Fevereiro',
    // MonthsEnum_3: 'Março',
    // MonthsEnum_4: 'Abril',
    // MonthsEnum_5: 'Maio',
    // MonthsEnum_6: 'Junho',
    // MonthsEnum_7: 'Julho',
    // MonthsEnum_8: 'Agosto',
    // MonthsEnum_9: 'Setembro',
    // MonthsEnum_10: 'Outubro',
    // MonthsEnum_11: 'Novembro',
    // MonthsEnum_12: 'Dezembro',

    // financial: 'financeiro',
    // 'code-management': 'Gerenciamento de código',
    // 'payment-summary': 'Resumo do pagamento',
    // 'users-credentials': 'Usuários com credenciais',
    // 'process-manager-user': 'Utilizadores Gestores de Processos',
    // 'technical-manager-user': 'Utilizadores Gestores de Técnicos',
    // 'commercial-manager-user': 'UItilizadores Gestores Comerciales',

    // process_managers: 'Gestores do Processos',
    // technical_managers: 'Gestores do Técnicos',
    // commercial_managers: 'Gerentes Comerciais',

    // ADD_NEW_ASSET_FORM_postalCode: 'Código postal',
    // ADD_NEW_ASSET_FORM_streeDoseNotExist: 'No está en el callejero',

    // assessments: 'Valoraciones',
    // nationalIdentityDocument: 'Documento nacional de identidad',
    // tab_information_updated_please_reload_tab: 'La información ha sido actualizada. Recargue la pestaña.',
    // TECHNICAL_MANAGER_USERS_add_technical_manager_user: 'Adicionar gerenciador de técnicos',
    // no_documents: 'No hay documentos',
    // from: 'desde a',
    // toDate: 'até',
    // cancelledDate: 'Data de cancelamento',
    // finishedDate: 'Finished de finalizacion',

    // REQUESTS_billing: 'Faturamento',
    // REQUESTS_createNewInvoice: 'Criar nova fatura',
    // incomeOrExpensesProvision: 'Provisão Renda/Despesas',
    // incomeOrExpensesInvoiced: 'Cobrança Renda/Despesas',
    // billingType: 'Tipo de cobrança',
    // billingStatus: 'Status de cobrança',
    // relatedAppraisals: 'Avaliações relacionadas',
    // finishedAppraisals: 'Avaliações Concluídas',
    // appraisalsWithInvoice: 'Avaliações com fatura',
    // amountsSummary: 'Resumo dos montantes',
    // faturas: 'Faturas',
    // generalData: 'Dados gerais',
    // addValorationToRequestInvoice: 'Adicionar avaliação à fatura',
    // selectAmountToIncludeInvoice: 'Selecione o valor a incluir na fatura',
    // confirmInvoice: 'Confirmar fatura',
    // allInvoiced: 'Facturado totalmente',
    // partialInvoiced: 'Facturado parcialmente',
    // IndividualByAsset: 'Particular por inmuebles',
    // GlobalToOrder: 'Global',
    // addAppraisalToInvoiceWarningAutoIndividual: 'El importe de la factura será el sumatorio de los importes confirmados de las valoraciones seleccionadas.',
    // addAppraisalToInvoiceWarningAutoGlobal: 'El importe de la factura será el indicado después la selección de las valoraciones.',
    // addAppraisalToInvoiceWarningManual: 'Los datos de facturación serán incluidos de forma manual después de la selección de las valoraciones',
    // notInvoiced: 'No facturado',
    // filesVolume: 'Volumen de expedientes',
    // filesAverageTime: 'Tiempos medios de expedientes',
    // REQUEST_notCancelled: 'No anuladas',
    // REQUEST_customerInvoiced: 'Valoraciones facturables a cliente',
    // APPRAISALS_notGenerateInvoice: 'No facturar a cliente',
    // REPORT_valuation_summary_element: 'Elemento',
    // REPORT_valuation_summary_registeredPropertyNumber: 'Finca Registral',
    // REPORT_valuation_summary_cadastralReference: 'Referencia Catastral',
    // REPORT_valuation_summary_adoptedSurface: 'Superficie Adoptada (m²)',
    // REPORT_valuation_summary_unitaryValue: 'Valor Unitario (€/m²)',
    // REPORT_valuation_summary_totalValue: 'Valor Total (€)',
    // REPORT_valuation_summary_adoptedMethod: 'Método Adoptado',
    // REPORT_reportVersionSelected: 'Versión del informe seleccionada',
    // REPORT_valuationSummary: 'Resumen de valoraciones',

    // AVM -TRANSLATES
    AVMNationalBankSpainCutomerTypes_1: 'Banco',
    AVMNationalBankSpainCutomerTypes_2: 'Caja de ahorro',
    AVMNationalBankSpainCutomerTypes_3: 'Cooperativas de crédito',
    AVMNationalBankSpainCutomerTypes_4: 'Establecimiento financiero de crédito y sociedades de garantía recíproca',
    AVMNationalBankSpainCutomerTypes_5: 'Entidades aseguradoras',
    AVMNationalBankSpainCutomerTypes_6: 'Administraciones y organismos públicos',
    AVMNationalBankSpainCutomerTypes_7: 'Institución de inversión colectiva inmobiliaria',
    AVMNationalBankSpainCutomerTypes_8: 'Fondo de pensiones',
    AVMNationalBankSpainCutomerTypes_9: 'Sociedad de gestión de activos',
    AVMNationalBankSpainCutomerTypes_10: 'Otras personas jurídicas',
    AVMNationalBankSpainCutomerTypes_11: 'Personas física',

    AVMPurposes_0: 'NotSpecified',
    AVMPurposes_1: 'Mortgage',
    AVMPurposes_2: 'Awarded',

    avm_save_preselection: 'Salvar pré-seleção',
    avm_name_preselection: 'Nome de pré-seleção',
    avm_title_preselection: 'Deseja salvar a pré-seleção?',
    avm_purpose: 'propósito de avaliação',
    avm_rServerApiState: 'Api Server Status',
    avm_rServerApiId: 'Server API ID',
    avm_totalValorationsValue: 'Valor total da avaliação',
    avm_cellSeparator: 'Caractere delimitador',
    avm_batchAssetStates: 'Status do ativo',
    avm_batchAssetTypes: 'Tipos de ativos',
    avm_batchAssetOrigins: 'Origem do ativo',
    avm_calculatedAvailableDataStates: 'Tipo de informação do ativo - Calculado',
    avm_originAvailableDataStates: 'Tipo de informação do ativo - Origem',
    avm_hasAssetCalculated: 'Você tem um ativo calculado atribuído?',
    avm_normalizedProcess: 'Processo de normalização',
    avm_normalized: 'O arquivo já foi normalizado',
    avm_noPendingTranslation: 'Nenhuma tradução pendente. Confirme para continuar.',

    AvailableDataStatesCustom_0: 'Sem informações',
     AvailableDataStatesCustom_1: 'Informações de superfície',
     AvailableDataStatesCustom_2: 'Informações de tipo',
     AvailableDataStatesCustom_3: 'Informações de tipo e superfície',

    languages_0: 'Espanhol',
    languages_1: 'Inglês',
    languages_2: 'Português',

    languagesButton: 'Idiomas'
  },
};
